import { create } from 'zustand';

export const useAppStore = create((set) => ({
  currentPage: 'landing',
  isPlaying: false,
  selectedProject: null,
  selectedPerson: null,
  showIntroVideo: true,

  setCurrentPage: (page) => {
    console.log('setCurrentPage called with:', page, 'at', new Date().toISOString());
    set({ currentPage: page });
  },
  setIsPlaying: (playing) => set({ isPlaying: playing }),
  setSelectedProject: (project) => set({ selectedProject: project }),
  setSelectedPerson: (person) => set({ selectedPerson: person }),
  setShowIntroVideo: (show) => {
    console.log('setShowIntroVideo called with:', show, 'at', new Date().toISOString());
    set({ showIntroVideo: show });
    console.log('showIntroVideo state updated');
  },
}));
